import "./Table.css"
var DeveloperPortalRecommendationsRow = function(props){
    return <div className="c_developerportal_companies_searchresults row">
        <div className="col-md-4">Company: {props.company}</div>
        <div className="col-md-2">Action: {props.action}</div>
        <div className="col-md-2">Target Price: {props.targetprice}</div>
        <div className="col-md-4">Symbol: {props.symbol}</div>
    </div>
}
export default DeveloperPortalRecommendationsRow